<div class="header">
  <h2>{{isEditingMode ? 'Edit' : 'Create'}} Email Template</h2>
</div>
<mat-card>
  <div class="mat-elevation-z0">
    <h3 class="sub-heading inline-item">Template Form</h3>
    <form [formGroup]="createEmailTemplateForm" (ngSubmit)="createEmailTemplate()" class="create-template-form">
      <mat-form-field appearance="outline" class="block">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" placeholder="Title" required />
      </mat-form-field>
      <mat-form-field appearance="outline" class="block">
        <mat-label>Subject</mat-label>
        <input matInput formControlName="subject" placeholder="Subject" required />
      </mat-form-field>
      <div>
        <angular-editor formControlName="content" [config]="editorConfig" placeholder="Content">
        </angular-editor>
      </div>
      <br>
      <button mat-flat-button type="submit" color="primary" class="inline-item full-width"
        [disabled]="createEmailTemplateForm.invalid">{{isEditingMode ? 'Update' : 'Create'}}</button>
    </form>
  </div>
</mat-card>
